import { useCallback } from 'react'

import { customerioTracker } from 'lib'
import { zaiUtils } from 'modules/zai/common/zai.utils'
import { ZAI_NATIVE_SIDE_CHAT_TOGGLE_EVENT } from 'modules/zai/zai-native-side-chat/zai-native-side-chat.consts'
import { FeatureFlagsStore } from 'stores'

import type { TZaiSideChatButtonModelReturn, TZaiSideChatButtonModelProps } from './zai-side-chat-button.types'

export const useZaiSideChatButtonModel = ({
  workspaceId,
}: TZaiSideChatButtonModelProps): TZaiSideChatButtonModelReturn => {
  const iframeTargetOrigin = zaiUtils.generateZaiChatSrc({ workspaceId, module: 'side-chat' })

  const handleClick = useCallback(() => {
    customerioTracker.track(customerioTracker.eventNames.FEATURE_USED, {
      feature: 'zai',
      action: 'open_side_chat',
    })

    const isNativeZaiChatEnabled = FeatureFlagsStore.getFeatureFlag('isNativeZaiChatEnabled')

    if (isNativeZaiChatEnabled) {
      window.dispatchEvent(new CustomEvent(ZAI_NATIVE_SIDE_CHAT_TOGGLE_EVENT))
      return
    }

    const iframe = document.querySelector('iframe[name="zai-side-chat-iframe"]') as HTMLIFrameElement | null

    if (!iframe?.contentWindow) return

    iframe.contentWindow.postMessage(
      {
        action: 'side-chat',
        origin: 'insights',
      },
      new URL(iframeTargetOrigin).origin
    )
  }, [iframeTargetOrigin])

  return {
    handleClick,
  }
}
